import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Sparkles, X } from "lucide-react";
import { useState, useEffect } from "react";

export default function TrialBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const key = `trial-banner-dismissed-${user?.id}`;
    if (sessionStorage.getItem(key)) setDismissed(true);
  }, [user?.id]);

  if (!user || !user.trial_active) return null;
  if (dismissed) return null;

  const days = user.trial_days_remaining;
  const dismiss = () => {
    sessionStorage.setItem(`trial-banner-dismissed-${user.id}`, "1");
    setDismissed(true);
  };

  return (
    <div className="bg-[#1C3F35] text-white" data-testid="trial-banner">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-2.5 flex items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="w-4 h-4 text-[#C1654B] shrink-0"/>
          <span className="truncate">
            <b>{days} day{days === 1 ? "" : "s"} left</b> in your Pro trial — unlock unlimited AI drafts, match scoring, and everything else.
          </span>
        </div>
        <div className="flex items-center gap-4 shrink-0">
          <Link to="/pricing" data-testid="trial-banner-upgrade" className="underline underline-offset-4 hover:text-[#C1654B] transition-colors">
            Keep Pro
          </Link>
          <button onClick={dismiss} data-testid="trial-banner-dismiss" className="text-white/60 hover:text-white p-1">
            <X className="w-4 h-4"/>
          </button>
        </div>
      </div>
    </div>
  );
}
